var MAX = 100;
var MIN = 0;
var STEP = 1;
var NO_OP = function NO_OP() {};
var VARIANTS = {
  FLOATING: 'floating',
  GREATER_THAN: 'greater-than',
  LESS_THAN: 'less-than'
};
var OPEN_ENDS = {
  BOTH: 'both',
  MAX: 'max',
  MIN: 'min'
};
var OPEN_END_SIZE_TOKENS = {
  GAP: 'small',
  WIDTH: 'medium'
};

export { MAX, MIN, NO_OP, OPEN_ENDS, OPEN_END_SIZE_TOKENS, STEP, VARIANTS };
//# sourceMappingURL=constants.js.map
